/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Free_ButtonInputs */



/**
* | output |
* | --- |
* | "Continue with Free" |
*
* @param {Signup_Free_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_free_button = /** @type {((inputs?: Signup_Free_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Free_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec l'offre Gratuite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Free fortfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua con Gratuito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить с Free")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar con Gratis")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续使用免费套餐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Free で続ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Free के साथ जारी रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar com o Gratuito")
	return /** @type {LocalizedString} */ ("Continue with Free")
});